module.exports = __webpack_public_path__ + "img/generate-report.565dc56b.svg";